import styled from 'styled-components';
import {
    CircularProgress,
    IconButton,
    ListItem,
    ListItemSecondaryAction,
    ListItemText,
    Paper,
    Typography,
    Fab
} from '@material-ui/core';
import { FlexDiv } from 'common/flex';

export const Container = styled.div<{disabled: boolean}>`
    height: 100%;
    display: flex;
    flex-direction: column;
    ${({ disabled }) => disabled && `
        pointer-events: none;
        opacity: 0.6;
    `}
`;

export const FabIcon = styled(Fab)<{isLastModifiedToday: boolean}>`
 && {
        min-width: 28px;
        border-style: ${props => props.isLastModifiedToday ? 'solid' : 'none'};
        border-width: ${props => props.isLastModifiedToday ? '2px' : '0px'};
        border-color: ${props => props.isLastModifiedToday ? props.theme.activeToday : ''};
    }
`;
export const Header = styled.div`
    height: 64px;
    background-color: ${props => props.theme.header};
    display: flex;
    align-items: center;
    box-shadow: 0px 0px 8px ${props => props.theme.secondary.main};
`;

export const SearchContainer = styled.div`
    flex: 1;
    padding: 12px 12px 12px 24px;
    display: flex;
    align-items: flex-end;
`;

export const SortContainer = styled.div`
    margin-right: 5px;
    border-radius: 20px;
    &:hover {
        background-color: white;
    }
`;

export const Title = styled(Typography)`
    flex: 1;
    text-align: center;
`;

export const New = styled(IconButton)`
    margin-right: 24px;  
`;

export const ContentContainer = styled.div<{expanded?: boolean}>`
    display: flex;
    flex-direction: row;
    width: 100%;
    height: calc(100% - ${props => props.expanded ? '128px' : '64px'});
`;

export const ListContainer = styled(Paper)`
    flex: 1; 
`;

export const FormContainer = styled.div`
    flex: 3;
    flex-direction: column;
    display: flex;
    margin: 10px;
    overflow: hidden;
`;

export const ButtonsContainer = styled.div`
    display: flex; 
    padding: 20px 0 6px 10px;
`;

export const ListText = styled(ListItemText)`
    
`;
export const CustomSecondaryAction = styled(ListItemSecondaryAction)`
    //display: none;
`;

export const CustomListItem = styled(ListItem)`
    && {
        padding: 0;
        margin: 0;
    }
    text-decoration: none;
`;
export const QuickTimerContainer = styled.div`
    padding:4px 0px;
    &:hover{
        background-color: ${props => props.theme.grey.light};
        cursor: pointer;
    }
    &:focus-within {
        background-color: ${props => props.theme.grey.light};
    }
`;

export const StyledNavTimerIconButton = styled(IconButton)`
    background: transparent !important;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const QuickTimerIcon = styled.div`
    border-left: 1px solid ${props => props.theme.primary.light};
`

export const CustomListItemContent = styled.div<{selected?: boolean}>`
    width: 100%;
    text-align: left;
    display: flex;
    align-items: center;
    padding: 0 20px;
    outline: none;
    &:hover{
        background: ${props => !props.selected && props.theme.white.main};
    }
    background: ${props => props.selected && props.theme.white.dark};
    transition: ${props => props.theme.animationsEnabled && 'all 0.1s'};
    &:focus{
        background: ${props => !props.selected && props.theme.white.main};
    }
`;

export const ListItemContent = styled.div`
    height: 70px;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 0 20px;
    &:hover ${CustomSecondaryAction}{
        display: block;
    }
`;
export const TimerHeaderContainer = styled.div`
  text-align: center;
  width: 185px;
  height: 52px;
`;
export const TimerHeaderText = styled.div`
    font-size: 20px;
    padding: 10px;
    color: ${props => props.theme.secondary.light};
`;
export const TimerHeader = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    &> div {
        margin: 4px 0px;  
      }
`;
// NavTimer
export const NavTimerContainer = styled.div<{disabled?: boolean}>`
    max-width: 290px;
    max-height: 64px;
    display: flex;
    flex: 1;
    flex-direction: row;
    &:first-child { 
        padding-left: 20px;
    }
    ${({ disabled }) => disabled && `
        pointer-events: none;
        opacity: 0.6;
    `}
`;
export const NewActions = styled.div`
    flex: 1;
    text-align: right;
`;
export const ChunksHeader = styled.div`
    display: grid;
    grid-template-columns: 24px 172px 1fr 34px;
    align-items: center;
    width: 100%;
    padding: 4px 0 6px 12px;
    font-size: 1.1125rem;
    font-weight: 300;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    cursor: pointer;
    border-bottom: 1px solid ${props => props.theme.highlighted.grey};
`;
export const ChunksHeaderDate = styled(FlexDiv)`
    color: ${props => props.theme.white.contrastText};
    margin-left: 12px;
`;
export const ChunksHeaderDuration = styled.div`
    font-weight: 400;
    color: ${props => props.theme.black.light};
`;
export const ExpandIcon = styled(IconButton)`
    height: 25px;
    width: 25px;
`;
export const TimerChunkList = styled.div`
    position: fixed;    
`;
export const EditTimeLabel = styled.div`
    margin-bottom: 10px;
`;
export const FabProgress = styled(CircularProgress)`
    position: absolute;
    top: -6;
    left: -6;
    z-index: 1;
`
export const AutoCompleteFilters = styled.div`
    flex: 2;
    padding-right: 12px;
`;
export const AdvancedHeader = styled('div')`
    height: 64px;
    background-color: ${props => props.theme.header};
    display: flex;
    padding-left: 24px;
`;
export const FilterButton = styled(IconButton)`
    align-self: center;
`;
export const DailyTimerHeader = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: center;
    background-color: ${props => props.theme.white.main};
    border-bottom: 1px solid ${props => props.theme.highlighted.grey};
    height: 64px;
`;
export const DailyTimerContainer = styled.div`
    width: 204px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: ${props => props.theme.secondary.light};
    font-weight: 500;
    border-right: 1px solid ${props => props.theme.highlighted.grey};
    height: 100%;
`;
export const DailyTimer = styled.div`
    width: 106px;
    text-align: center;
    font-size: 18px;
`;
export const DailyTimerSection = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;
    padding-left: 24px;
    width: 140px;
    border-right: 1px solid ${props => props.theme.highlighted.grey};
`;
export const DailyTimerLabel = styled.div`
    font-size: 12px;
    color: ${props => props.theme.secondary.light};
`;
export const DailyTimerValue = styled.div<{ colorCode?: string }>`
    font-size: 20px;
    color: ${({colorCode, theme}) => colorCode === 'billable' ? theme.summary.blue : colorCode === 'nonBillable' ? theme.summary.red : ''};
`;